
import { ReactNode, useEffect } from "react";
import { Navigate, useLocation, Outlet } from "react-router-dom";
import { useAuth } from "./providers/AuthProvider";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { devLog } from "@/utils/devLog";

export function ProtectedRoute() {
  const location = useLocation();
  const { session, initialSessionProcessed, loading } = useAuth();

  // Enhanced debug logging
  useEffect(() => {
    devLog("[ProtectedRoute] Rendered with:", { 
      path: location.pathname,
      hasSession: !!session,
      initialSessionProcessed,
      loading,
      renderTime: new Date().toISOString()
    });
  }, [location.pathname, session, initialSessionProcessed, loading]);

  // Only show loading when we're truly in a loading state
  // This is critical for preventing premature rendering
  if (loading || !initialSessionProcessed) {
    return (
      <div className="h-screen flex flex-col items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary mb-4" />
        <p className="text-muted-foreground">Loading your session...</p>
      </div>
    );
  }

  if (!session) {
    devLog("[ProtectedRoute] No session, redirecting to auth from", location.pathname);
    toast.error("Please log in to access this page");
    return <Navigate to="/student-auth" state={{ from: location.pathname }} replace />;
  }

  return <Outlet />;
}
